import {each}  from 'lodash';
import {x, x0} from '../_helpers';

export default class Sharer {

    constructor() {
        this.triggers = x('[js-share]');
        if (this.triggers) {
            this.init();
        }
    }

    _openPopup(url, width, height) {
        if (!url) return;
        width = width ? width : 600;
        height = height ? height : 600;
        let pos = {
            left: screen.width / 2 - width / 2,
            top: screen.height / 2 - height / 2
        };
        window.open(url, "Share", "width=" + width + ",height=" + height + ",left=" + pos.left + ",top=" + pos.top);
    }

    _twitterShare(url) {
        this._openPopup(url, 690, 300);
    };

    _facebookShare(url) {
        this._openPopup(url, 540, 400);
    };

    _handleEvents() {
        each(this.triggers, el => {

            el.addEventListener('click', evt => {
                evt.preventDefault();

                let $this = el;
                let url = $this.getAttribute("href");

                switch (true) {
                    case /facebook\.com/g.test(url):
                        this._facebookShare(url);
                        break;
                    case /twitter\.com/g.test(url):
                        this._twitterShare(url);
                        break;
                    default:
                        return false;

                }
            });
        });
    }

    init() {
        this._handleEvents();
    }

}